import React from 'react';
import { StyledUtpCardGrid, utpCardGridStylesMap } from './utp-card-grid-styles';
import { UtpCardGridProps } from './utp-card-grid-types';

export const UtpCardGrid: React.FC<UtpCardGridProps> = ({ cardNumber, children }) => (
  <StyledUtpCardGrid className={utpCardGridStylesMap[cardNumber]} cardNumber={cardNumber}>
    {children}
  </StyledUtpCardGrid>
);
